module.exports = __webpack_public_path__ + "img/icon-other.82d9d1e7.svg";